// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__4gZgq","itemWrapper":"styles_itemWrapper__3ILqy","arrowWrapper":"styles_arrowWrapper__24e3g"};